"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLiterals = exports.getBaseKey = void 0;
const getBaseKey = (roleType) => {
    const baseKeys = {
        VERIZON_SAVINGS: 'mbModalPartnerships',
    };
    return baseKeys[roleType] || '';
};
exports.getBaseKey = getBaseKey;
const getLiterals = (baseKey, translate) => {
    return {
        title: translate(`${baseKey}.title`),
        cancelLink: translate(`${baseKey}.dismissLink`),
        continueButton: translate(`${baseKey}.continueButton`),
        contentDescription01: translate(`${baseKey}.description01`),
        contentDescription02: translate(`${baseKey}.description02`),
        closeButtonAltText: translate(`${baseKey}.a11y.mbModalClose.crossIcon`),
    };
};
exports.getLiterals = getLiterals;
//# sourceMappingURL=partnership.utils.js.map